/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

import { BridgeCommands } from '../../../src/bridge.commands';

import { Types } from '../../types/index';

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetStatus: BridgeCommands.Command<
    undefined,
    Types.Common.Mcpserver.GetStatusReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'McpServer',
    method: 'GetStatus',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetMcpServerTools: BridgeCommands.Command<
    undefined,
    Types.Common.Mcpserver.GetMcpServerToolsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'McpServer',
    method: 'GetMcpServerTools',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetAccessLevel: BridgeCommands.Command<
    Types.Common.Mcpserver.SetAccessLevelParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'McpServer',
    method: 'SetAccessLevel',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const McpOverlayToolCallNotification: BridgeCommands.Command<
    {},
    Types.Common.Mcpserver.McpOverlayToolCallNotificationReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'McpServer',
    method: 'McpOverlayToolCallNotification',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SendMcpOverlayToolResponse: BridgeCommands.Command<
    Types.Common.Mcpserver.SendMcpOverlayToolResponseParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'McpServer',
    method: 'SendMcpOverlayToolResponse',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const McpGameEventNotification: BridgeCommands.Command<
    Types.Common.Mcpserver.McpGameEventNotificationParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'McpServer',
    method: 'McpGameEventNotification',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const McpOverlayStateChangedNotification: BridgeCommands.Command<
    Types.Common.Mcpserver.McpOverlayStateChangedNotificationParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'McpServer',
    method: 'McpOverlayStateChangedNotification',
    persistent: false
};

export const Mcpserver = {
GetStatus,
GetMcpServerTools,
SetAccessLevel,
McpOverlayToolCallNotification,
SendMcpOverlayToolResponse,
McpGameEventNotification,
McpOverlayStateChangedNotification
};
